module.exports = __webpack_public_path__ + "img/2.cfce9519.jpg";